"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PhoneType;
(function (PhoneType) {
    PhoneType["WORK"] = "Work";
    PhoneType["BUSINESS"] = "Business";
})(PhoneType = exports.PhoneType || (exports.PhoneType = {}));
var AddressType;
(function (AddressType) {
    AddressType["SCHOOL"] = "School";
    AddressType["OFFICE_MAILING"] = "Office Mailing";
    AddressType["HOME"] = "Home";
    AddressType["OFFICE_STREET"] = "Office Street";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var EmailType;
(function (EmailType) {
    EmailType["PERSONAL"] = "Personal";
    EmailType["BUSINESS"] = "Business";
})(EmailType = exports.EmailType || (exports.EmailType = {}));
var AccountRecordType;
(function (AccountRecordType) {
    AccountRecordType["Person"] = "PersonAccount";
    AccountRecordType["Business"] = "Business";
})(AccountRecordType = exports.AccountRecordType || (exports.AccountRecordType = {}));
//# sourceMappingURL=index.js.map